var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLinkedinDark = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.42227V11.8348H9.41704V7.69133C9.41704 6.66891 9.04036 5.96936 8.12556 5.96936C7.42601 5.96936 6.99552 6.45366 6.83408 6.88416C6.78027 7.04559 6.72646 7.26084 6.72646 7.5299V11.8348H4.1435C4.1435 11.8348 4.19731 4.83932 4.1435 4.13976H6.72646V5.216C7.04933 4.67788 7.69507 3.92452 9.04036 3.92452C10.7085 3.92452 12 5.05456 12 7.42227ZM1.45291 0.426758C0.591927 0.426758 0 1.01869 0 1.77205C0 2.52541 0.538116 3.11734 1.3991 3.11734C2.3139 3.11734 2.85202 2.52541 2.85202 1.77205C2.90583 0.964875 2.36771 0.426758 1.45291 0.426758ZM0.161435 11.8348H2.74439V4.13976H0.161435V11.8348Z",
    fill: "#2878B7"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLinkedinDark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/linkedin-dark.5f89f91d.svg";
export { ForwardRef as ReactComponent };